import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import { get_gallery } from "../../../../redux/dataSlice";
// import store from "../../../redux/store";
import {
  Container,
  Grid,
  GridItem,
  Image,
  Text,
  useDisclosure,
} from "@chakra-ui/react";
import { Loader } from "../../../../utils/LayoutUtils";
import BreadCrumName from "../../../../components/BreadCrumName";
import ImageModal from "../../../../components/ImageModal";
import store from "../../../../redux/store";
import { toast } from "react-toastify";

const AllPhoto = () => {
  const { state } = useLocation();
  const [loading, setLoading] = useState(false);
  const [list, setList] = useState([]);
  const [url, setUrl] = useState("");
  const { isOpen, onOpen, onClose } = useDisclosure();
  const navigate = useNavigate();

  const get_photos = async () => {
    try {
      const body = new FormData();
      body.append("action", "gallery");
      body.append("id", state.ID);
      const responce = await fetch(
        process.env.REACT_APP_BASE_URL + "Gallery.php",
        {
          method: "POST",
          body: body,
        }
      );
      const res = await responce.json();
      if (res.success) {
        setList(res.data);
      } else {
        toast.error(res.message);
      }
    } catch (error) {}
  };
  useEffect(() => {
    get_photos();
  }, []);

  return (
    <Container maxW={"container.xl"} py={5}>
      <BreadCrumName
        current={state.Event_name}
        titlelist={[
          { name: "Home", to: "/" },
          { name: "Group Gallery", to: "/group-gallery" },
        ]}
      />
      <Container maxW={"container.xl"} p={4}>
        {loading && list?.length == 0 ? (
          <Loader />
        ) : (
          <Grid
            templateColumns={[
              "repeat(1, 1fr)",
              "repeat(1, 1fr)",
              "repeat(2, 1fr)",
              "repeat(3, 1fr)",
              "repeat(4, 1fr)",
            ]}
            gap={5}
          >
            {list?.map((item, index) => (
              <GridItem
                key={index}
                w="100%"
                bg="#fff"
                shadow={"rgba(0, 0, 0, 0.24) 0px 3px 8px"}
                display={"flex"}
                flexDirection={"column"}
                cursor={"pointer"}
                onClick={() => {
                  setUrl(item.Url);
                  onOpen();
                }}
              >
                <Image
                  src={item.Url}
                  h={"100%"}
                  w={"100%"}
                  objectFit={"cover"}
                  alignSelf={"center"}
                  onClick={() => setUrl(item.Url)}
                />
              </GridItem>
            ))}
          </Grid>
        )}
      </Container>
      <ImageModal url={url} isOpen={isOpen} onClose={onClose} />
    </Container>
  );
};

export default AllPhoto;
